import React from 'react';
import DataProtection from '../../containers/ActivityLog/DataProtection';

class ActivityLogPage extends React.Component {
  render = () => (
    <DataProtection />
  )
}

export default ActivityLogPage;
